import React, {createContext} from 'react';

import {sendEventsToNativeApp} from '../utils/ClientAppUtils';
//TODO: Need to rename as we are using for partner app as well
const ClientAppCommunicationContext = createContext({});

class ClientAppCommsHandlers {
  subscriptions: ((eventName) => void)[] = [];

  handleClientAppEvents = (event) => {
    this.subscriptions.forEach((fn) => fn(event));
  };

  sendEventsToClientApp = (event) => {
    sendEventsToNativeApp(event);
  };

  //TODO: need to support multiple event handlers
  subscribeToEvents = (handlerFn: (eventName) => void) => {
    if (window) {
      window.handleClientAppEvents = handlerFn;
    }
  };
}

export {ClientAppCommunicationContext, ClientAppCommsHandlers};
